var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[(_vm.hasMore)?_c('span',{class:(_vm.prefixCls + "-more"),on:{"click":_vm.handleLoad}},[_vm._v("\n        "+_vm._s(_vm.loading ? _vm.t('page.loading') : _vm.t('page.loadMore'))+"\n        "),_c('i',{class:[(_vm.prefixCls + "-icon"), ( _obj = {}, _obj[(_vm.prefixCls + "-icon-loading")] = _vm.loading, _obj )]})]):_vm._e(),_vm._v(" "),(!_vm.hasMore && _vm.hasData)?_c('span',[_vm._v("\n        "+_vm._s(_vm.t('page.noMore'))+"\n    ")]):_vm._e()])
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/base/page/page.vue?vue&type=template&id=6fa2c28c&
// module id = 153
// module chunks = 0